module.exports = __webpack_public_path__ + "img/barcode.3245f0ff.svg";